import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Chip from "@mui/material/Chip";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import Stack from "@mui/material/Stack";
import { paths } from "config/paths";
import { useFormik } from "formik";
import RouterLink from "next/link";
import { FC } from "react";
import * as Yup from "yup";

import { MangoLogo } from "~ui-components/components/atoms/mango-logo";
import { CenteredLayout } from "~ui-components/components/organisms/centered-layout";
import { PasswordSchema } from "../sign-up-v2";

export const UpdatePasswordV2Schema = Yup.object({
	code: Yup.string().required("Required"),
	password: PasswordSchema,
	retypedPassword: Yup.string().required("Required"),
});

export type UpdatePasswordV2FormValues = Yup.InferType<
	typeof UpdatePasswordV2Schema
>;

export interface UpdatePasswordV2Props {
	form: ReturnType<typeof useFormik<UpdatePasswordV2FormValues>>;
}

export const UpdatePasswordV2: FC<UpdatePasswordV2Props> = ({ form }) => {
	return (
		<CenteredLayout>
			<Stack spacing={4}>
				<div>
					<Box
						component={RouterLink}
						href={paths.home}
						sx={{ display: "inline-block", fontSize: 0 }}>
						<MangoLogo
							width={122}
							height={32}
						/>
					</Box>
				</div>
				<Card>
					<CardHeader
						title={
							<>
								Reset your password&nbsp;
								<Chip
									size="small"
									label="v2"
								/>
							</>
						}
					/>
					<CardContent>
						<Stack
							spacing={2}
							component="form"
							onSubmit={form.handleSubmit}>
							<FormControl>
								<InputLabel>Verify code</InputLabel>
								<OutlinedInput
									autoFocus
									{...form.getFieldProps("code")}
									error={!!form.touched.code && !!form.errors.code}
								/>
								{!!form.touched.code && !!form.errors.code && (
									<FormHelperText error>{form.errors.code}</FormHelperText>
								)}
							</FormControl>
							<FormControl>
								<InputLabel>Password</InputLabel>
								<OutlinedInput
									type="password"
									{...form.getFieldProps("password")}
									error={!!form.touched.password && !!form.errors.password}
								/>
								{!!form.touched.password && !!form.errors.password && (
									<FormHelperText error>{form.errors.password}</FormHelperText>
								)}
							</FormControl>
							<FormControl>
								<InputLabel>Re-type password</InputLabel>
								<OutlinedInput
									type="password"
									{...form.getFieldProps("retypedPassword")}
									error={
										!!form.touched.retypedPassword &&
										!!form.errors.retypedPassword
									}
								/>
								{!!form.touched.retypedPassword &&
									!!form.errors.retypedPassword && (
										<FormHelperText error>
											{form.errors.retypedPassword}
										</FormHelperText>
									)}
							</FormControl>
							<Button
								type="submit"
								variant="contained"
								disabled={form.isSubmitting || !form.isValid}>
								Update
							</Button>
						</Stack>
					</CardContent>
				</Card>
			</Stack>
		</CenteredLayout>
	);
};
